module.exports = __webpack_public_path__ + "static/img/left1.a75c2eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/left1.png
// module id = //WJ
// module chunks = 1